import {colors} from '@/constants/theme/colors'

export const DOUGHNUT_CHART_CARD_SCHEME_COLORS = [
    colors.primary600,
    colors.orange,
    colors.blue1,
    colors.red1,
    colors.blue2,
    colors.grey4
]

export const DOUGHNUT_CHART_ISSUING_BANK_COLORS = [
    colors.primary600,
    colors.yellow2,
    colors.blue4,
    colors.red2,
    colors.blue5,
    colors.blue6
]
